import { useState } from 'react';
import { Card, Button } from 'react-bootstrap';
import ModalWaiting from "../Components/ModalWaiting";

function LineCall({ params, userID, userName }) {
  const [waitingShow, setWaitingShow] = useState(false);
  const title = params === "albumdigital" ? "アルバム再生工房" : "思い出スライド工房";

  return (
    <>
      <style jsx>{`
        .container-wrapper { display: flex; flex-direction: column; height: 100vh; background: #f8f9fa; }
        .content-area { flex-grow: 1; padding: 20px; overflow-y: auto; display: flex; justify-content: center; }
        .maincard { width: 100%; max-width: 500px; border: none; }
        .card-title-custom { font-size: 1.25rem; font-weight: bold; color: #1a73e8; text-align: center; padding: 10px 0; }
        .footer-area { background: #ffffff; padding: 15px; display: flex; justify-content: center; border-top: 1px solid #ddd; }
      `}</style>

      <div className="container-wrapper">
        <div className="content-area">
          <Card className="maincard shadow-sm">
            <Card.Body>
              <Card.Title className="card-title-custom mb-4">
                {title} <br/> LINE電話相談予約
              </Card.Title>
              
              <div className="text-center p-5">
                 {/* ここに予約の日時情報（選択・確認UI）が入ります */}
                 <p className="text-muted">予約可能な日時情報を読み込んでいます...</p>
              </div>

            </Card.Body>
          </Card>
        </div>
        <div className="footer-area">
          <Button variant="outline-secondary" className="px-4" onClick={() => window.close()}>閉じる</Button>
        </div>
        <ModalWaiting show={waitingShow} />
      </div>
    </>
  );
}

export default LineCall;
